import {useEffect, useState} from "react";

export const useVisibility = (element: any) => {
    const [visibility, setVisibility] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) =>
            setVisibility(entry.isIntersecting)
        );

        observer.observe(element.current);
        return () => {
            observer.disconnect();
        };
    }, [element]);

    return visibility;
}